module.exports = __webpack_public_path__ + "static/media/48416563_2308807562527755_5800086469750030336_o.4e51b255.jpg";